interface ComputerWithAdjustableWrenchSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithAdjustableWrenchSVG = ({
  color,
  style,
}: ComputerWithAdjustableWrenchSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="52"
    viewBox="0 0 57 52"
    fill="none"
  >
    <g clipPath="url(#clip0_519_19545)">
      <path
        d="M14.3728 12.1049L22.0035 7.77734L29.6237 12.1049L22.0035 16.5056"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0035 25.3066L14.3728 20.9059V12.1045"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0035 25.3066L29.6237 20.9059V12.1045"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0035 16.5049V22.3481"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3171 32.3829H3.77354C2.00699 32.3829 0.585388 30.9508 0.585388 29.1947V3.77311C0.585388 2.00656 2.00699 0.584961 3.77354 0.584961C4.98609 0.584961 41.331 0.584961 40.223 0.584961C41.9896 0.584961 43.4112 2.01702 43.4112 3.77311V17.9682"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0697 32.3838L9.12543 37.3071H22.0035H32.8223"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.3031 40.7869C48.7212 40.2747 49.2334 39.8357 49.8083 39.5012C49.8083 39.5012 49.8188 39.5012 49.8292 39.5012C49.8292 39.5012 49.8397 39.5012 49.8502 39.5012C51.0104 38.8218 52.3902 38.6023 53.6968 38.9263L54.3345 39.0831L56.2787 35.7172L55.8188 35.2469C54.8885 34.2747 54.3972 32.9681 54.3972 31.6197C54.3972 31.6092 54.3972 31.5883 54.3972 31.5779C54.3972 30.2399 54.8885 28.9333 55.8188 27.9716L56.2787 27.5012L54.3345 24.1354L53.6968 24.2922C52.3902 24.6162 51.0209 24.3967 49.8606 23.7172C49.8502 23.7172 49.8292 23.7068 49.8188 23.6963C48.6481 23.0273 47.7596 21.9507 47.3937 20.6545L47.216 20.0273H43.3275L43.1498 20.6545C42.7735 21.9507 41.8954 23.0169 40.7247 23.6963C40.7247 23.6963 40.7143 23.6963 40.7038 23.6963C40.7038 23.6963 40.6934 23.6963 40.6829 23.6963C39.5226 24.3758 38.1428 24.5953 36.8362 24.2712L36.1986 24.1145L34.2543 27.4803L34.7143 27.9507C35.6446 28.9228 36.1359 30.2294 36.1359 31.5779C36.1359 31.5883 36.1359 31.6092 36.1359 31.6197C36.1359 32.9577 35.6446 34.2643 34.7143 35.226L34.2543 35.6963L36.1986 39.0622L36.8362 38.9054C38.1428 38.5814 39.5122 38.8009 40.6725 39.4803C40.6829 39.4803 40.7038 39.4908 40.7143 39.5012C41.2474 39.8043 41.7177 40.2016 42.115 40.651"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M43.547 41.7587V34.2953C42.4808 33.6891 41.7596 32.5497 41.7596 31.2326C41.7596 29.9887 42.4077 28.9016 43.3902 28.2744V29.9469C43.3902 30.4173 43.6411 30.8563 44.0592 31.0967C44.8118 31.5357 45.7526 31.5357 46.5052 31.0967C46.9129 30.8563 47.1742 30.4173 47.1742 29.9469V28.2744C48.1463 28.9016 48.8049 29.9887 48.8049 31.2326C48.8049 32.5497 48.0836 33.6891 47.0174 34.2953V41.7587V44.8842C48.0836 45.4904 48.8049 46.6298 48.8049 47.9469C48.8049 49.1908 48.1568 50.2779 47.1742 50.9051V49.2326C47.1742 48.7622 46.9233 48.3232 46.5052 48.0828C45.7526 47.6438 44.8118 47.6438 44.0592 48.0828C43.6516 48.3232 43.3902 48.7622 43.3902 49.2326V50.1316V50.9051C42.4181 50.2779 41.7596 49.1908 41.7596 47.9469C41.7596 46.6298 42.4808 45.4904 43.547 44.8842V41.7587Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_19545">
        <rect width="57" height="51.4913" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithAdjustableWrenchSVG;
